import React from "react";
import { FiEdit2 } from "react-icons/fi";

interface AccountSettingRowProps {
  icon?: React.ReactNode;
  label: React.ReactNode;
  description?: React.ReactNode;
  /** The current value (usually a read-only input). */
  children?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

/** Label / value / action row used inside the account settings cards. */
export const AccountSettingRow = ({
  icon,
  label,
  description,
  children,
  action,
  className = "",
}: AccountSettingRowProps) => (
  <div className={`flex flex-col gap-3 px-5 py-4 sm:flex-row sm:items-center sm:gap-6 ${className}`}>
    <div className="flex items-center min-w-0 gap-3 sm:w-60 sm:shrink-0">
      {icon && (
        <span className="inline-flex items-center justify-center rounded w-9 h-9 shrink-0 bg-surface-2 text-ink-3">
          {icon}
        </span>
      )}
      <div className="min-w-0">
        <div className="text-sm font-medium text-ink">{label}</div>
        {description && <p className="mt-0.5 text-xs text-ink-3">{description}</p>}
      </div>
    </div>
    <div className="flex items-center min-w-0 gap-3 sm:flex-1">
      <div className="flex-1 min-w-0">{children}</div>
      {action && <div className="flex items-center gap-2 shrink-0">{action}</div>}
    </div>
  </div>
);

/** Read-only value input that reads as plain text inside a settings row. */
export const accountValueInputClass =
  "block w-full min-w-0 h-auto p-0 text-sm truncate bg-transparent border-0 shadow-none outline-none cursor-default text-ink-2 placeholder:text-ink-4 focus:ring-0";

export const AccountEditButton = ({
  onClick,
  label,
}: {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
}) => (
  <button
    type="button"
    onClick={onClick}
    className="zs-btn zs-btn-secondary zs-btn-sm"
    aria-label={label ? `Edit ${label}` : "Edit"}
  >
    <FiEdit2 className="w-3.5 h-3.5" />
    <span>Edit</span>
  </button>
);
